import axios from "axios";
import type { AxiosInstance, AxiosError } from "axios";

const baseURL = import.meta.env.PROD
  ? (import.meta.env.VITE_ULA_API_URL || "")
  : "";

// 파일 업로드/다운로드 전용 Bucket API. 메인 API와 별도 호스트.
const bucketBaseURL = import.meta.env.PROD
  ? (import.meta.env.VITE_ULA_API_BUCKET_URL || "")
  : "";

export const api = axios.create({
  baseURL,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

export const bucketApi = axios.create({
  baseURL: bucketBaseURL,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});

const attachInterceptors = (instance: AxiosInstance) => {
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token && config.headers) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userInfo");
        window.location.href = "/login";
        return new Promise(() => {});
      }

      const data = error.response?.data as
        | { message?: string; Message?: string }
        | undefined;
      const message =
        data?.message ??
        data?.Message ??
        (error.request ? "서버에 연결할 수 없습니다." : error.message);

      return Promise.reject(new Error(message));
    },
  );
};

attachInterceptors(api);
attachInterceptors(bucketApi);
